import axios, { AxiosError } from 'axios';
import { StripeCoupon } from '~/types/stripe';
import { DefaultGetResponse, DefaultUpdateOrCreateResponse } from './rest';
import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
} from 'react-query';

export const queryKeys = {
  all: ['customer-coupon'],
};

const { team } = window.Bonjoro;

export type GetCustomerCouponResponse = DefaultGetResponse<{
  coupon?: StripeCoupon;
  description: string;
}>;

export const getCustomerCoupon = () =>
  axios.get<GetCustomerCouponResponse>(`/api/v2/teams/${team.id}/coupon`);

export type RedeemCouponResponse = DefaultUpdateOrCreateResponse<never>;

export const redeemCoupon = (coupon: string) =>
  axios.post<RedeemCouponResponse>(`/api/v2/teams/${team.id}/redeem-coupon`, {
    coupon,
  });

export interface UseCustomerCouponParams {
  options?: UseQueryOptions<
    DefaultGetResponse<GetCustomerCouponResponse>,
    AxiosError
  >;
}

export const useCustomerCoupon = ({ options }: UseCustomerCouponParams) =>
  useQuery<DefaultGetResponse<GetCustomerCouponResponse>, AxiosError>(
    queryKeys.all,
    async () => {
      const res = await getCustomerCoupon();
      return res.data;
    },
    options
  );

export interface RedeemCouponArgs {
  coupon: string;
}

export interface RedeemCouponErrorArgs {
  response: {
    data: {
      message: string;
    };
  };
}

export const useRedeemCoupon = (
  options?: UseMutationOptions<
    RedeemCouponResponse,
    RedeemCouponErrorArgs,
    RedeemCouponArgs
  >
) =>
  useMutation(async ({ coupon }) => {
    return (await redeemCoupon(coupon)).data;
  }, options);
